/**
 * Default GPS values for Geneva when no stored position is available
 */

import { type FilteredGpsData, type GpsData, type GpsPredictionData, type RawGpsData } from "../types/Navigation";

/**
 * Geneva coordinates and default GPS values
 */
export const GENEVA_DEFAULT_POSITION = {
    "latitude":  46.2044,
    "longitude": 6.1432,
    "altitude":  375, // Geneva altitude above sea level
    "heading":   0,   // North direction
    "speed":     0,   // Stationary
    "accuracy":  100, // Default accuracy for default position
} as const;

/**
 * Create base GPS data for Geneva
 */
export const createGenevaBaseGpsData = (): GpsData => ( {
    "latitude":  GENEVA_DEFAULT_POSITION.latitude,
    "longitude": GENEVA_DEFAULT_POSITION.longitude,
    "altitude":  GENEVA_DEFAULT_POSITION.altitude,
    "heading":   GENEVA_DEFAULT_POSITION.heading,
    "speed":     GENEVA_DEFAULT_POSITION.speed,
    "timestamp": Date.now(),
} );

/**
 * Create default RawGpsData for Geneva
 */
export const createGenevaRawGpsData = (): RawGpsData => ( {
    ...createGenevaBaseGpsData(),
    "accuracy":         GENEVA_DEFAULT_POSITION.accuracy,
    "altitudeAccuracy": 50,
} );

/**
 * Create default FilteredGpsData for Geneva
 */
export const createGenevaFilteredGpsData = (): FilteredGpsData => ( {
    ...createGenevaBaseGpsData(),
    "accuracy": GENEVA_DEFAULT_POSITION.accuracy * 0.8, // Filtered is more accurate
} );

/**
 * Create default GpsPredictionData for Geneva
 */
export const createGenevaGpsPredictionData = (): GpsPredictionData => ( {
    ...createGenevaBaseGpsData(),
    "constrained": false,
    "confidence":  1.0, // High confidence for default position
} );
